export const BOTTOM_APPBAR_OFFSET = 80;
export const MOBILE_CONTENT_BOTTOM_PADDING = 96;
